@if (emailsForTags?.mailAccountId) {
  <app-add-tags-dialog
    [initialTags]="initialTags"
    [loadTags]="loadTags"
    [insertTag]="insertTag"
    [saveTags]="saveTags"
    [isDrawer]="isDrawer"
    (closeEventEmitter)="closeEventEmitter.emit()" />
}
